import "../styles/Networks.css"

import { InstagramIcon, LinkedinIcon, TiktokIcon } from "../utils/icons.utils"

function Networks() {

    return (
        <>
        <div className="body body-networks">
            <section className="networks__container">
                <div className="networks__header">
                    <h1 className="networks-title">Réseaux sociaux</h1>
                </div>

                <div className="networks_body">
                    <a className="networks-button" target="_blank" href="https://www.instagram.com/kenzo.simontin/" rel="noopener noreferrer">
                        <InstagramIcon className="networks-icon networks-instagram-icon" />
                        Instagram
                    </a>

                    <a className="networks-button" target="_blank" href="https://www.tiktok.com/@kenzo.simontin" rel="noopener noreferrer">
                        <TiktokIcon className="networks-icon networks-tiktok-icon" />
                        Tiktok
                    </a>

                    <a className="networks-button" target="_blank" href="http://www.linkedin.com/in/kenzo-simon-tintinaglia" rel="noopener noreferrer">
                        <LinkedinIcon className="networks-icon networks-linkedin-icon" />
                        Linkedin
                    </a>
                </div>
            </section>
        </div>
        </>
    )
}

export default Networks